export default "__VITE_ASSET__DD252HbO__"